import {
    ApplicationURLTriggerLocation,
    CreditCardProductCategory,
} from '@appTypes/EligibilityApi.interface'

import { getAppConfig } from '@utils/getAppConfig'

import { decodePrePopToken } from './decodePrePopToken'

export interface GetCreditCardApplicationUrlOptions {
    cam?: string
    category: CreditCardProductCategory
    clickId: string
    clickSource: string
    client?: string
    customerId: string
    dailyId: string
    featured: boolean
    gclid?: string
    guaranteedApr?: number
    guaranteedCreditLimit?: number
    isBestMatchCard: boolean
    isKnownCustomer: string
    isNewOffer: boolean
    k?: string
    m?: string
    permanentId: string
    prepopulationToken?: string
    productCode: string
    productIndex: number
    provider: string
    score: number
    scoreId: string
    sendId?: string
    status: string
    thirdPartyReference: string
    trigger: ApplicationURLTriggerLocation
    visitGuid: string
}

export const getCardApplicationUrl = (
    options: GetCreditCardApplicationUrlOptions
): string => {
    const appConfig = getAppConfig()

    const searchQuery = {
        csrc: options.clickSource,
        ccid: options.productCode,
        status: options.status,
        hdscore: options.score,
        customerOrigin: 'Account',
        customerId: options.customerId,
        customerType: 'Account',
        clickId: options.clickId,
        isKnownCustomer: options.isKnownCustomer,
        client: options.client ?? 'web',
        scoreId: options.scoreId,
        visitGuid: options.visitGuid,
        dailyId: options.dailyId,
        permanentId: options.permanentId,
        m: options.m,
        cam: options.cam,
        k: options.k,
        sendId: options.sendId,
        gclid: options.gclid,
        category: options.category,
        provider: options.provider,
        trigger: options.trigger,
        rowNumber: options.productIndex,
        isBestMatchCard: options.isBestMatchCard || '',
        isNewOffer: options.isNewOffer,
        guaranteedApr: options.guaranteedApr,
        guaranteedCreditLimit: options.guaranteedCreditLimit,
        platform: 'web',
        ...(options.featured && { featured: true }),
    } as const

    const url = new URL(appConfig.CLICK_OUT_URL)

    Object.keys(searchQuery).forEach(searchKey => {
        const sk = searchKey as keyof typeof searchQuery

        if (searchQuery[sk] != null) {
            url.searchParams.append(
                searchKey,
                searchQuery[sk] as unknown as string
            )
        }
    })

    return `${url.toString()}${
        options.thirdPartyReference ? `&${options.thirdPartyReference}` : ''
    }&pt=${options.prepopulationToken ? options.prepopulationToken : ''}`
}
